export class CustomerAddressParent {
    public recID: number = 0;
    public name: string = '';
    public description: string = '';
    public address1: string = '';
    public city: string = '';
    public state: string = '';
    public zip: string = '';
    public editing: boolean = false;
    public selected: boolean = false;
}
